import React from "react";
import { useState, useEffect, useMemo} from "react";
import useSWR from "swr";
import "swiper/css";
import "./styles/DetallesCompra.css";
import { useLocation, Link, useParams} from 'react-router-dom';
import { ComponerMensajeDialog } from '../View/Mensajes';


const fetcher = (url) =>
    fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).then((res) => {
      if (!res.ok) throw new Error(res.statusText);
      return res.json();
});

let baseUrl;
if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
else baseUrl='https://app-formacion.vercel.app';


const getCompraDetalle = async ([urlCompra]) => {
    const compraData = await fetcher(urlCompra);

    const productos = await Promise.all(
        compraData.Id_Contenido.map(async (contId) => {
        try {
            const detalle = await fetcher(
            `${baseUrl}/api/productos/${contId}`
            );
            return {
                ...detalle.producto,
                tutor: detalle.tutor,
            };
        } catch {
            return null;
        }
        })
    );

    //Filtrar nulos y ordenar productos por orden de llegada
    //compraData.productos = productos.filter((p) => p !== null);
    compraData.productos = productos;
    return compraData;
};


const DetalleCompra = () => {
    //const location = useLocation();
    const { id } = useParams();
    const { state } = useLocation();

    //Estado para poder enviar mensajes a tutor
    const [compose, setCompose] = useState({ abierto: false, inicial: {} });

    const fallbackData = useMemo(
        () =>
          state?.compra
            ? {
                ...state.compra,
                productos: state.compra.productos || [],
              }
            : undefined,
        [state]
    );

    const { data: compra, error, mutate: mutateCompras } = useSWR(
        [`${baseUrl}/api/compras/${id}`],
        getCompraDetalle,
        {
          fallbackData,
          dedupingInterval: 30 * 60 * 1000,    // 30 min cache
          revalidateOnFocus: false,            // no refetch on tab focus
          revalidateOnReconnect: false,        // no refetch on reconnect
          keepPreviousData: true,              // mantiene datos anteriores durante refetch
        }
    );
    
    if (error) {
        return(
            <div className="principal">
                <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "2rem" }}>Error cargando compra: {error.message}</p>;
            </div>
        )
    }
    if (!compra) {
        return(
            <div className="principal">
                <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "2rem" }}>Cargando detalle de la compra…</p>;
            </div>
        )
    }

    //Productos devueltos, se convierte los ids a string para comparar
    const devueltosStr = (compra.ProductosDevueltos || []).map((id) =>
        id.toString()
    );
               
    return(
        <div className="principal">
            <h1>Detalles de la compra con código {compra.Codigo}</h1>
            
            <div className='informacionCompra'>
                <div className="infoPrincipal">
                    <div className="fechaPrecio">
                        <div>
                            <h4 className="label">Fecha de compra:</h4>
                            <span className="value"> 
                                <strong>
                                    {new Date(compra.Fecha).toLocaleDateString("es-ES", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    }).replace(/\//g, "-")}
                                </strong>
                            </span>
                                
                            <h4 className="label">Precio total:</h4>
                            <strong><span className="value">{(compra.Precio).toFixed(2)} €</span></strong>
                        </div>
                    </div>

                </div>
                <div className="listaProductos">
                    <h3>Productos comprados</h3>                  
                        <ul>
                            {compra.productos.map((prod, index) => {
                                if (!prod || (prod.Nombre === null && prod.Tematica === null && prod.Descripcion === null && prod.ImagenPortada === null && prod.FechaSubida === null)) {
                                    return (
                                        <li key={`eliminado-${index}`}>
                                            <div style={{ fontStyle: "italic", color: "#888" }}>
                                                <span>Este producto fue eliminado por su autor.</span>
                                                <div style={{ marginTop: "8px" }}>
                                                    <strong>Precio: </strong>
                                                    {prod && prod.Precio
                                                        ? prod.Precio.toFixed(2) + " €"
                                                        : "—"
                                                    }
                                                </div>
                                            </div>
                                        </li>
                                    );
                                }
                            
                                const tutorEliminado = !prod.tutor;
                                const estaDevuelto = devueltosStr.includes(prod._id.toString());

                                
                                return (
                                    <li key={prod._id}>
                                        <div className="productoInfo">
                                            <div className="cabecera">
                                                <div className="imagenCont"><span><img src={`data:image/png;base64,${prod.ImagenPortada}`} alt={`${prod.Nombre}`}/></span></div> <div className="tituloLista"><span><strong>{prod.Nombre}</strong></span></div> 
                                            </div>
                                            <span>
                                                Precio: {(prod.Precio).toFixed(2)} €  
                                                {/*prod===null ? (<span>Producto eliminado</span>) : ()*/}
    
                                            </span>
                                        </div>
                                        <div className="tutorInfo">
                                                <span style={{marginTop: '20px'}}>Tutor del contenido: </span>
                                                    {tutorEliminado ? (
                                                        <span style={{ fontStyle: "italic" }}>
                                                            Tutor eliminado
                                                        </span>
                                                    ) : (
                                                    <span style={{ marginTop: '20px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                        <Link className="enlace" to={{ pathname: `/detalleTutor/${prod.tutor._id}`, state: { tutor: prod.tutor }}} title={"Ver información del tutor"}>
                                                            <p>{prod.tutor.Nombre} {prod.tutor.Apellidos} </p>

                                                        </Link>
                                                        <button className="enlace" style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit', textDecoration: 'none' }} title={"Contactar"}
                                                            onClick={() => {
                                                                setCompose({
                                                                    abierto: true,
                                                                    inicial: {
                                                                        Destinatarios: prod.tutor.Usuario,
                                                                        Asunto: "",
                                                                        Contenido: "",
                                                                        Archivo: null,
                                                                        respuestaA: false,
                                                                        leerSoloDestinatarios: true,
                                                                        leerSoloAsunto: false,
                                                                    }
                                                                })
                                                            }}
                                                        >
                                                            ({prod.tutor.Usuario})
                                                        </button>
                                                    </span>
                                                )}
                                        </div>

                                        <div className="botonesContainer">
                                            {estaDevuelto ? (
                                                <span style={{textAlign: "center", justifyContent: "center", verticalAlign: "center", fontStyle: "italic", color: "#888"}}> Este producto ha sido devuelto </span>
                                            ) : (
                                                <button onClick={() => {
                                                    const asuntoDevolucion = `Solicitud para gestionar la devolución del producto ${prod.Nombre}`;
                                                    setCompose({
                                                        abierto: true,
                                                            inicial: {
                                                                Destinatarios: prod.tutor.Usuario,
                                                                Asunto: asuntoDevolucion,
                                                                Contenido: "",
                                                                Archivo: null,
                                                                respuestaA: false,
                                                                leerSoloDestinatarios: true,
                                                                leerSoloAsunto: true,
                                                            },
                                                        });
                                                    }}
                                                    disabled={tutorEliminado}
                                                >
                                                    {tutorEliminado
                                                        ? "Tutor eliminado"
                                                        : "Gestionar devolución"
                                                    }
                                                </button>
                                            )}
                                            
                                            {/*prod.tutor===null ? (<span>Usuario eliminado</span>) : (<Link><button></Link>)*/}
                                            <Link className="enlace" to={{ pathname: `/detalleContenido/${prod._id}`, state: { producto: prod, tutor: prod.tutor }}} title={"Ver información del producto"}>
                                                <button>Ver detalles del producto</button>
                                            </Link>

                                            <ComponerMensajeDialog
                                                abierto={compose.abierto}
                                                inicial={compose.inicial}
                                                onClose={() => setCompose({ abierto: false, inicial: {} })}
                                            />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>            
                </div>
            </div>
        </div>  
    );
};

export default DetalleCompra;
